module.exports = __webpack_public_path__ + "static/media/banner-van-tai.9b596233.jpg";